/* @jsx h */
import { defineComponent, h } from "vue";
import type { ReservationSettingsUpdateHandler } from "@lemmonhq/types";
import { useLocalization } from "@lemmonhq/uikit";

export interface GeneralSettingsProps {
  enabled: boolean;
  autoConfirm: boolean;
  onUpdate: ReservationSettingsUpdateHandler;
}

export const GeneralSettings = defineComponent<GeneralSettingsProps>({
  name: "GeneralSettings",
  props: ["enabled", "autoConfirm", "onUpdate"],
  setup(props) {
    const { t } = useLocalization();

    return () => (
      <div class="space-y-4">
        <div class="form-control">
          <label class="label cursor-pointer justify-start gap-4">
            <input
              type="checkbox"
              class="toggle toggle-primary"
              checked={props.enabled}
              onChange={(e) =>
                props.onUpdate(
                  "reservations_enabled",
                  (e.target as HTMLInputElement).checked,
                )
              }
            />
            <div>
              <span class="label-text  font-medium">
                {t("settings.reservations.enable_reservations")}
              </span>
              <p class="text-sm  mt-1">
                {t("settings.reservations.enable_reservations_desc")}
              </p>
            </div>
          </label>
        </div>

        <div class="form-control">
          <label class="label cursor-pointer justify-start gap-4">
            <input
              type="checkbox"
              class="toggle toggle-success"
              checked={props.autoConfirm}
              disabled={!props.enabled}
              onChange={(e) =>
                props.onUpdate(
                  "reservations_auto_confirm",
                  (e.target as HTMLInputElement).checked,
                )
              }
            />
            <div>
              <span class="label-text  font-medium">
                {t("settings.reservations.auto_confirm")}
              </span>
              <p class="text-sm  mt-1">
                {t("settings.reservations.auto_confirm_desc")}
              </p>
            </div>
          </label>
        </div>
      </div>
    );
  },
});
